import { writable } from 'svelte/store';

export const localizedCountryNamesStore = writable<Record<string, string>>({});
